module.exports = __webpack_public_path__ + "static/media/1009962.473fc231.jpg";